import getConfig from 'next/config';
import { HTTPClient } from '../api';

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;

export interface IRegister {
  fullname: string;
  gender: string;
  date: number;
  month: number;
  year: number;
  phone: string;
  password: string;
  repassword: string;
}

export const SignupAPIService = async (payload: IRegister) => {
  const name = payload.fullname.split(' ');
  const phone = payload.phone.replace(/\s/g, '');

  const data = {
    username: phone,
    password: payload.password,
    phone_number: phone,
    last_name: name.length > 1 ? name.pop() : '',
    first_name: name.join(' '),
    source_type: 'media_ui',
    registrationCode: {},
    parentId: {},
    organizationId: {},
  };

  const request = {
    method: 'POST',
    body: JSON.stringify(data),
  };

  const userauthRes = await HTTPClient(`${BASE_URL_MEDIA}api/accounts/userauth/`, request);

  const response = {
    status: userauthRes.id ? 'success' : 'fail',
    phoneNumber: userauthRes.phone_number,
    password: payload.password,
    data: userauthRes,
  };

  return response;
};
export default SignupAPIService;
